import { computed } from 'vue';
import parsePhoneNumber from 'libphonenumber-js/mobile';
import { useBaseDataStore } from '@/user/store/baseDataStore.ts';

export function usePhoneNumber() {
  const { maklertelefon, maklertelefonMobil } = useBaseDataStore();

  const mobilNumber = computed(() => {
    if (!maklertelefon && !maklertelefonMobil) return null;

    const phoneNumber = parsePhoneNumber(maklertelefon ?? '', 'DE');
    const phoneNumberMobil = parsePhoneNumber(maklertelefonMobil ?? '', 'DE');

    if (phoneNumber?.country === 'DE' && phoneNumber?.getType() === 'MOBILE') {
      return phoneNumber.number;
    } else if (phoneNumberMobil?.country === 'DE' && phoneNumberMobil?.getType() === 'MOBILE') {
      return phoneNumberMobil.number;
    } else {
      return null;
    }
  });

  return { mobilNumber };
}
